export const SET_MEDIA_UPLOAD_STATUS = 'SET_MEDIA_UPLOAD_STATUS'